/**
 * FiltersBar
 * -----------
 * Presents the city, date, pagination, and refresh controls that drive the
 * ScheduleVisualizer data queries.
 */
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

const FiltersBar = ({
  cityOptions,
  selectedCity,
  onCityChange,
  selectedDate,
  onDateChange,
  rowsPerPage,
  onRowsPerPageChange,
  rowsPerPageOptions,
  onRefresh,
  loading,
}) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    spacing={2}
    alignItems={{ xs: 'stretch', md: 'flex-end' }}
  >
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel id="city-filter-select">Filter by city</InputLabel>
      <Select
        labelId="city-filter-select"
        value={selectedCity}
        label="Filter by city"
        onChange={onCityChange}
      >
        <MenuItem value="">
          <em>All Cities</em>
        </MenuItem>
        {cityOptions.map((city) => (
          <MenuItem key={city} value={city}>
            {city}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <TextField
      size="small"
      type="date"
      label="Date"
      value={selectedDate}
      onChange={onDateChange}
      InputLabelProps={{ shrink: true }}
      sx={{
        '& input::-webkit-calendar-picker-indicator': {
          filter: 'invert(1)',
        },
      }}
    />

    <FormControl size="small" sx={{ minWidth: 160 }}>
      <InputLabel id="rows-per-page-select">Rows per page</InputLabel>
      <Select
        labelId="rows-per-page-select"
        value={rowsPerPage}
        label="Rows per page"
        onChange={onRowsPerPageChange}
      >
        {rowsPerPageOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option} rows
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <Button variant="outlined" color="inherit" onClick={onRefresh} disabled={loading}>
      {loading ? 'Refreshing…' : 'Refresh'}
    </Button>
  </Stack>
);

export default FiltersBar;